import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-544636e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-import-button__icon" }
const _hoisted_2 = ["onClick"]

import { TaskImportServiceEnum } from "@/enums";
import {
  TirPmButton,
  TirPmDropdown,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-components";
import { TaskImportDropdownOptionModel } from "./models";
import { ArrowDownTrayIcon } from "tir-style-system/icons/solid";
import { CrossLinedIcon } from "tir-style-system/icons/outline";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'task-import-button',
  props: {
  /**Выбранный сервис */
  modelValue: { type: String as PropType<TaskImportServiceEnum> },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





const options: TaskImportDropdownOptionModel[] = [
  new TaskImportDropdownOptionModel({
    Id: TaskImportServiceEnum.Weeek,
    Text: "Weeek.ru",
  }),
];

/**Обработчик клика на кнопку */
const onClickButton = (event: MouseEvent) => {
  if (props.modelValue !== undefined) {
    event.stopPropagation();
    emit("update:modelValue", undefined);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmDropdown), {
    options: options,
    "popover-position": {
      left: '-0.625rem',
      top: '$el:height',
    },
    "is-disabled": __props.modelValue !== undefined
  }, {
    target: _withCtx(({ isOpened }) => [
      _createVNode(_unref(TirPmButton), {
        variant: _unref(TirPmButtonVariantEnum).SecondaryState,
        size: _unref(TirPmButtonSizeEnum).Small,
        onClick: onClickButton
      }, {
        leftSlot: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!isOpened && __props.modelValue === undefined)
              ? (_openBlock(), _createBlock(_unref(ArrowDownTrayIcon), { key: 0 }))
              : (_openBlock(), _createBlock(_unref(CrossLinedIcon), { key: 1 }))
          ])
        ]),
        _: 2
      }, 1032, ["variant", "size"])
    ]),
    optionList: _withCtx(({ option }) => [
      _createElementVNode("div", {
        class: "task-import-button__option",
        onClick: ($event: any) => (emit('update:modelValue', option.Id))
      }, _toDisplayString(option.Text), 9, _hoisted_2)
    ]),
    _: 1
  }, 8, ["is-disabled"]))
}
}

})